import React, { memo, useEffect, useState } from 'react';
import { education } from '../../../constants/storageKeys';
import { Switch, Route, NavLink, useRouteMatch, Redirect } from 'react-router-dom';
import KeepAlive, { useAliveController, useActivate, useUnactivate } from 'react-activation';
import styles from './EductionTabs.module.less';
import EduRecommend from '../EduRecommend/EduRecommend';
import EduCategory from '../EduCategory/EduCategory';
import EduMine from '../EduMine/EduMine';
import { useHistory, useLocation } from 'react-router-dom';
import { CONTEXT } from '../../../config';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { getEducationNewTabs } from '../../../actions/education';
import { logNative, localSetItem, localGetItem } from '../../../utils/utils';
import Loading from '../../../components/Loading/Loading';

const SelectEducationTag = createSelector(
  state => state.education,
  education => education.newTabs,
);

export default memo(() => {
  const dispatch = useDispatch();
  const { path, url } = useRouteMatch();
  const { pathname } = useLocation();

  const history = useHistory();
  const { drop } = useAliveController();
  const eduNewTabs = useSelector(SelectEducationTag);
  const [newTabs, setNewTabs] = useState([]);

  useEffect(() => {
    if (!localGetItem('EDUCATION_TABS')) {
      dispatch(getEducationNewTabs({ pageType: 'education' }));
    }
  }, []);

  useEffect(() => {
    if (eduNewTabs.length > 2) {
      localSetItem('EDUCATION_TABS', JSON.stringify(eduNewTabs));
    }
    if (localGetItem('EDUCATION_TABS')) {
      setNewTabs(JSON.parse(localGetItem('EDUCATION_TABS')));
    }
  }, [eduNewTabs]);

  const handleClick = tab => {
    history.push({ pathname: `${url}/${tab.route}`, query: { code: tab.code } });
  };
  return (
    <div className={styles.education}>
      {newTabs.length > 2 && (
        <div className={styles.tabs}>
          {newTabs.map(tab => (
            <div
              className={`${styles.tab_item} ${
                pathname === `${url}/${tab.route}` ? styles.active : ''
              }`}
              key={tab.name}
              onClick={() => handleClick(tab)}
            >
              {tab.name}
            </div>
          ))}
        </div>
      )}
      {newTabs.length > 2 && (
        <Switch>
          {newTabs.map(tab => {
            if (tab.code) {
              return (
                <Route
                  key={tab.name}
                  exact
                  path={`${url}/${tab.route}`}
                  render={() => <EduRecommend code={tab.code} />}
                />
              );
            }
          })}
          <Route exact path={`${url}/category`}>
            <EduCategory />
          </Route>
          <Route exact path={`${url}/mine`}>
            <EduMine />
          </Route>
          <Redirect to={`${CONTEXT}/education/pceduSelect`} />
        </Switch>
      )}
      {newTabs.length <= 2 && <Loading />}
    </div>
  );
});
